<template>
  <div class="information">
    <el-row type="flex" align="middle" style="margin-bottom: 20px;">
      <div class="fontSize-30 padding" style="margin-right: 40px;">备用金余额：{{ balance }}CNY</div>
      <el-button type="primary" @click="Reservefund">备用金明细</el-button>
      <el-button type="primary" @click="PettyCashApplication = true">备用金申请</el-button>
    </el-row>
    <el-form class="custom-formScreen" :model="formScreen" ref="formScreen" label-width="4.8vw" inline>
      <el-form-item label="分公司" prop="BranchOffice">
        <el-select v-model="formScreen.BranchOffice" filterable placeholder="请选择" @change="selectChange">
          <el-option v-for="item in listBranch" :key="item.id" :label="item.companyFullName"
            :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="子公司" prop="Subsidiary">
        <el-select v-model="formScreen.Subsidiary" filterable placeholder="请选择">
          <el-option v-for="item in listSon" :key="item.id" :label="item.companyFullName" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单据类型" prop="financeReportingType">
        <el-select v-model="formScreen.financeReportingType" placeholder="请选择">
          <el-option v-for="item in typeList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="单据状态" prop="status">
        <el-select v-model="formScreen.status" placeholder="请选择">
          <el-option v-for="item in checkList" :key="item.value" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="收件人" prop="recipient">
        <el-select v-model="formScreen.recipient" filterable placeholder="请选择">
          <el-option v-for="item in recipientList" :key="item" :label="item" :value="item"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="开始日期" prop="startTimeString">
        <el-date-picker v-model="formScreen.startTimeString" align="right" type="date" placeholder="选择开始日期"
          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item label="结束日期" prop="endTimeString">
        <el-date-picker v-model="formScreen.endTimeString" align="right" type="date" placeholder="选择结束日期"
          format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
      </el-form-item>
      <el-form-item label="批次号：" prop="batchNo">
        <el-input v-model.trim="formScreen.batchNo" placeholder="批次号搜索"></el-input>
      </el-form-item>
      <el-form-item label="有无批次号" prop="hasBatchNo">
        <el-select v-model="formScreen.hasBatchNo" filterable placeholder="请选择">
          <el-option :key="0" label="无" :value="0"></el-option>
          <el-option :key="1" label="有" :value="1"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label=" " prop="searchString" style="width: 40%">
        <el-input v-model.trim="formScreen.searchString" placeholder="全字段搜索"
          style="width: calc(100% - 140px);"></el-input>
        <el-button type="primary" @click="searchForm" style="margin-left: 10px;">搜索</el-button>
        <el-button type="primary" @click="resetForm('formScreen')">重置</el-button>
      </el-form-item>
    </el-form>
    <div style="margin:10px 0;">
      <el-button type="primary" @click="Freightcollectedit">收货运费</el-button>
      <el-button type="primary" @click="packagingmaterials">包材提交</el-button>
      <el-button type="primary" @click="addThirdParty">添加三方</el-button>
      <el-button type="primary" @click="downExcel">导出地址</el-button>
      <el-button type="primary" style="float:right;" v-show="isShow" :disabled="EditDisabled"
        @click="batchEdit">批量编辑退件运费</el-button>
      <el-button type="primary" style="float:right;" v-show="isShow" :disabled="EditDisabled"
        @click="batchGenerate">批量生成批次号</el-button>
      <!-- <a href="" @click="export1" download="财务申报.xlsx">导出</a> -->
    </div>
    <el-table :data="listTable" border tooltip-effect="dark" v-loading="loadingTable"
      @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center"></el-table-column>
      <el-table-column prop="orderId" width="230" label="订单号/订单ID" align="left">
        <template slot-scope="scope">
          <div>订单号：{{ scope.row.amazonOrderId }}</div>
          <div>订单ID：{{ scope.row.orderId }}</div>
          <el-row style="display: flex;align-items: center;">
            <el-tag v-if="scope.row.outInterceptStatus === 1" type="danger" effect="dark" size="mini">拦截</el-tag>
            <el-tooltip class="item" effect="dark" content="订单冻结" placement="bottom" v-if="scope.row.isFreeze === 1">
              <i class="element-icons hx-snow" style="font-size: 40px;color: #1296db;line-height: 40px;"></i>
            </el-tooltip>
          </el-row>
        </template>
      </el-table-column>
      <el-table-column width="220" label="单据号、批次号/数量" align="left">
        <template slot-scope="scope">
          <div v-if="scope.row.financeReportingType === 2">
            <p v-if="scope.row.receiptType== 1">单据号：{{scope.row.purchaseNumber }}</p>
            <p v-if="scope.row.receiptType== 4">单据号：{{scope.row.unknownNumber }}</p>
            <p>
              <span v-if="scope.row.batchNo ==null">批次号：-</span>
              <span v-if="scope.row.batchNo !==null">批次号：{{scope.row.batchNo}}</span>
              <span> / </span>
              <span>{{scope.row.returnCount}}</span>
            </p>
          </div>
          <div v-else style="text-align: center;">
            <span>- -</span>
          </div>

        </template>
      </el-table-column>
      <el-table-column width="150" label="类型/原国内单号" align="center">
        <template slot-scope="scope">
          <div v-if="scope.row.financeReportingType === 1">收件运费</div>
          <!-- Freightcollect -->
          <div v-else-if="scope.row.financeReportingType === 2">退件运费</div>
          <!-- Returnfreight -->
          <div v-else-if="scope.row.financeReportingType === 3">第三方国际运费</div>
          <!-- packingmaterials -->
          <div v-else-if="scope.row.financeReportingType === 4">特殊包材费用</div>
          <div>{{scope.row.internalConveyNumber}}</div>
        </template>
      </el-table-column>
      <el-table-column prop="receiptNumber" width="150" label="退件国内单号" align="center"></el-table-column>
      <el-table-column prop="charge" width="80" label="费用" align="center"></el-table-column>
      <el-table-column width="80" label="状态" align="center">
        <template slot-scope="scope">
          <div style="color: #0565b7;" v-if="scope.row.status === 0">未处理</div>
          <div v-else-if="scope.row.status === 1">已处理</div>
        </template>
      </el-table-column>
      <el-table-column width="400" label="收件地址" align="center">
        <template slot-scope="scope">
          <p>{{scope.row.recipientName}} - - {{scope.row.recipientTelephone}}</p>
          <p>{{scope.row.receivingAddress}}</p>
        </template>
      </el-table-column>
      <el-table-column prop="userName" width="100" label="操作人" align="center"></el-table-column>
      <el-table-column prop="createTime" sortable width="110" label="创建时间" align="center"></el-table-column>
      <el-table-column prop="updateTime" sortable width="110" label="更新时间" align="center"></el-table-column>
      <!-- <el-table-column prop="branchCompanyName" label="所属分公司" width="200" align="center"></el-table-column>
      <el-table-column prop="subCompanyName" label="所属子公司" width="200" align="center"></el-table-column> -->
      <el-table-column width="200" prop="ziName" label="所属公司" align="center">
        <template slot-scope="scope">
          <div>
            <span>{{ scope.row.branchCompanyName }}</span>
            <span v-if="scope.row.branchCompanyName && scope.row.subCompanyName">&nbsp;-&nbsp;</span>
            <span>{{ scope.row.subCompanyName }}</span>
          </div>
        </template>
      </el-table-column>
      <el-table-column label="操作" fixed="right" width="80" align="center">
        <template slot-scope="scope">
          <i v-if="scope.row.financeReportingType === 1" class="el-icon-edit-outline fontSize-30"
            @click="Freightcollectedit(scope.row)"></i>
          <i v-else-if="scope.row.financeReportingType === 2" class="el-icon-edit-outline fontSize-30"
            @click="Returnfreightedit(scope.row)"></i>
          <i v-else-if="scope.row.financeReportingType === 3" class="el-icon-edit-outline fontSize-30"
            @click="Threepartyfreightedit(scope.row)"></i>
          <i v-else-if="scope.row.financeReportingType === 4" class="el-icon-edit-outline fontSize-30"
            @click="packagingmaterials(scope.row)"></i>
        </template>
      </el-table-column>
    </el-table>
    <div class="pagination-container">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="page"
        :page-sizes="[20, 50, 100, 200, 300]" :page-size="size" layout="total, sizes, prev, pager, next, jumper"
        :total="total"></el-pagination>
    </div>

    <Freightcollect ref="Freightcollect" @confirm="freightcollectConfirm" />
    <Returnfreight ref="Returnfreight" @confirm="threepartyfreightConfirm" />
    <Packingmaterials ref="Packingmaterials" />
    <Threepartyfreight ref="Threepartyfreight" @confirm="threepartyfreightConfirm" @confirm2="handleThirdParty" />
    <Plpackingmaterials ref="Plpackingmaterials" @confirm="plpackingmaterialsConfirm" />

    <el-dialog title="备用金明细" :visible.sync="dialogTableVisible" width="55%">
      <el-table :data="pettyCash" :header-cell-style="{ textAlign: 'center' }" border tooltip-effect="dark"
        style="width: 100%">
        <el-table-column prop="receiptNumber" label="单据号"></el-table-column>
        <el-table-column prop="receiptType" label="单据类型"></el-table-column>
        <el-table-column prop="receiptMoney" label="单据金额"></el-table-column>
        <el-table-column prop="receiptBalance" label="余额"></el-table-column>
        <el-table-column prop="createTime" label="时间"></el-table-column>
      </el-table>
      <el-row type="flex" justify="center">
        <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2"
          :current-page="currentPage2" :page-sizes="[50, 100, 200, 400]" :page-size="pagesize2"
          layout="total, sizes, prev, pager, next, jumper" :total="total2"></el-pagination>
      </el-row>
    </el-dialog>

    <el-dialog title="备用金申请" :visible.sync="PettyCashApplication" width="25%" style="margin-top:20px;">
      <el-input placeholder="请输入内容" v-model="receiptMoney" style="margin-top:10px;">
        <template slot="prepend">
          金额：
        </template>
      </el-input>

      <el-input placeholder="请输入内容" v-model="remark" style="margin-top:10px;">
        <template slot="prepend">
          备注：
        </template>
      </el-input>

      <div slot="footer" class="dialog-footer">
        <el-button @click="PettyCashApplication = false">取 消</el-button>
        <el-button type="primary" @click="pettyCashSubmit">提 交</el-button>
      </div>
    </el-dialog>

    <el-dialog top="8vh" title="批量编辑退件运费" :visible.sync="dialogVisible" width="35%">
      <el-form ref="form" label-width="100px" class="forms">
        <el-form-item label="分公司：">
          <el-input v-model="batchinformation.subCompanyName" readonly></el-input>
        </el-form-item>
        <el-form-item label="收货地址：">
          <el-input type="textarea" rows="3" resize="none" v-model="batchinformation.receivingAddress"
            readonly></el-input>
        </el-form-item>
        <el-form-item label="收件人：">
          <el-input v-model="batchinformation.recipientName" readonly></el-input>
        </el-form-item>
        <el-form-item label="收件人电话：">
          <el-input v-model="batchinformation.recipientTelephone" readonly></el-input>
        </el-form-item>
        <el-form-item label="国内单号：">
          <el-input v-model="batchinformation.internalConveyNumber" readonly></el-input>
        </el-form-item>
        <el-form-item label="退件运单：">
          <el-input v-model.trim="batchForm.receiptNumber"></el-input>
        </el-form-item>
        <el-form-item label="退货数量：">
          <el-input-number :min="1" size="mini" v-model="batchForm.returnCount"></el-input-number> 个
        </el-form-item>
        <el-form-item label="申报总金额：">
          <el-input style="width:130px;" v-model.trim="batchForm.totalCharge"></el-input>
        </el-form-item>
        <el-form-item label="说明：">
          <el-input type="textarea" rows="3" v-model="batchForm.description"></el-input>
        </el-form-item>
        <el-form-item label=" ">
          <el-upload ref="upload" :action="action" list-type="picture-card" :on-success="handleAvatarSuccess"
            :on-preview="handlePictureCardPreview" :on-remove="handleRemove" :headers="customHeaders">
            <i class="el-icon-plus" style="color: #0724ef;"></i>
          </el-upload>
        </el-form-item>

      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="EditSub">确 定</el-button>
      </span>
    </el-dialog>

  </div>
</template>

<script>
import Freightcollect from "./Financialdeclarationt/Freightcollect"; //收件运费
import Returnfreight from "./Financialdeclarationt/Returnfreight"; //退件运费
import Packingmaterials from "./Financialdeclarationt/Packingmaterials"; //包材费用
import Threepartyfreight from "./Financialdeclarationt/Threepartyfreight"; //第三方运费
import Plpackingmaterials from "./Financialdeclarationt/Plpackingmaterials"; //包材批量提交
import { Baseurl, ajaxPost } from "../../api/api/api";

export default {
  name: "Financialdeclaration",
  components: {
    Freightcollect,
    Returnfreight,
    Packingmaterials,
    Threepartyfreight,
    Plpackingmaterials,
  },
  data() {
    return {
      page: 1,
      size: 20,
      total: 0,
      UserInfo: {},
      listBranch: [],
      listSon: [],
      recipientList:[],
      isShow:false,
      dialogVisible:false,

      action: Baseurl + "imageController/uploadImage",
      customHeaders: { token: localStorage.getItem("token") },
      imageData:[],

      dialogTableVisible: false,
      formScreen: {
        BranchOffice: "", //分公司
        Subsidiary: "", //子公司
        startTimeString: "",
        endTimeString: "",
        searchString: "",
        financeReportingType: "",
        status: "",
        recipient:"",
        batchNo:"",
        hasBatchNo:"",
      },
      batchForm:{
        receiptNumber:"",
        returnCount:"",
        totalCharge:"",
        description:"",
        imageList:[],
      },
      checkList: [
        {
          value: "0",
          label: "未处理",
        },
        {
          value: "1",
          label: "已处理",
        },
      ],
      typeList: [
        {
          value: "1",
          label: "收件运费",
        },
        {
          value: "2",
          label: "退件运费",
        },
        {
          value: "3",
          label: "第三方国际运费",
        },
        {
          value: "4",
          label: "特殊包材费用",
        },
      ],
      listTable: [],
      ReservefundList: [
        {
          Number: "",
          type: "第三方运费",
          Amount: "1000",
          time: "2020.2.9  17：30",
        },
      ],
      pettyCash: [],
      total2: 0,
      PettyCashApplication: false,
      currentPage2: 1,
      pagesize2: 50,
      receiptMoney: "",
      remark: "",
      balance: 0,
      loadingTable: false,
      multipleSelection:"",
      EditDisabled:true,
      itemId:"",
      batchinformation:""
    };
  },
  created() {
    this.UserInfo = JSON.parse(localStorage.getItem("role"));
    this.getTableList();
    this.getBranchCompanyList();
    this.selectrecipientList();
  },
  methods: {
    searchForm() {
      this.page = 1
      if(this.formScreen.BranchOffice!==""&&this.formScreen.Subsidiary!==""&&this.formScreen.financeReportingType == "2"&&this.formScreen.recipient!==""&&this.formScreen.status == "0"){
        this.isShow = true
      }else{
        this.isShow = false
      }
      this.getTableList();
    },
    resetForm(formName) {
      this.page = 1
      this.$refs[formName].resetFields();
      this.listSon = [];
      this.isShow = false
      this.getTableList();
    },
    handleSelectionChange(val) {
        this.multipleSelection = val;
        if (this.multipleSelection.length > 0) {
            this.EditDisabled = false;
        }
        if (this.multipleSelection.length === 0) {
            this.EditDisabled = true;
        }
        this.itemId = this.multipleSelection.map(item=>{return item.id})
    },
    batchEdit(){
      this.dialogVisible = true
      var obj = {
        ids:this.itemId
      }
      ajaxPost(Baseurl + "financeReportingController/getReceivingAddress",obj).then(res => {
        if(res.data.code == 200){
          this.batchinformation = res.data.data
        }
      });
    },
    EditSub(){
      this.dialogVisible = false
      for (var i = 0; i < this.imageData.length; i++) {
          this.batchForm.imageList.push(this.imageData[i].data);
      }
      var obj = {
        ids:this.itemId,
        receiptNumber:this.batchForm.receiptNumber,
        totalCharge:this.batchForm.totalCharge,
        returnCount:this.batchForm.returnCount,
        imageList:this.batchForm.imageList,
        description:this.batchForm.description,
        status:1,
        roleId:this.UserInfo.rid,
      }
      ajaxPost(Baseurl + "financeReportingController/batchUpdateFinanceReporting",obj).then(res => {
        if(res.data.code == 200){
          this.$message.success("批量编辑退件运费")
          this.getTableList();
        }else{
          this.$message.error(res.data.data)
        }
        this.batchForm.imageList = []
        this.batchForm.receiptNumber = ""
        this.batchForm.totalCharge = ""
        this.batchForm.returnCount = ""
        this.batchForm.description = ""
      });
      this.subscribeAjax()
    },
    subscribeAjax(){
      var obj = {
        number:this.batchForm.receiptNumber,
        companyId:this.batchinformation.companyId
      }
      ajaxPost(Baseurl + "conveyNumberQueryController/subscribe",obj).then(res => {
        if(res.data.code == 200){
          this.$message.success("订阅成功")
        }else{
          this.$message.error(res.data.data)
        }
      });
    },
    batchGenerate(){
      var obj = {
        ids:this.itemId
      }
      ajaxPost(Baseurl + "financeReportingController/batchGetBatchNo",obj).then(res => {
        if(res.data.code == 200){
          this.$message.success("批量生成批次号成功")
          this.getTableList();
        }
      });
    },
    handleAvatarSuccess(file, fileList) {
        this.imageData.push(file);
    },
    handleRemove(file, fileList) {
        this.imageData = [];
        for (var i = 0; i < fileList.length; i++) {
            this.imageData.push(fileList[i].response);
        }
    },
    handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
    },
    handleSizeChange(val) {
      this.size = val;
      this.getTableList();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getTableList();
    },
    // 收货运费
    Freightcollectedit(row = {}) {
      this.$refs.Freightcollect.init(row);
    },

    // 退件运费
    Returnfreightedit(row = {}) {
      this.$refs.Returnfreight.init(row);
    },
    // 第三方运费
    Threepartyfreightedit(row = {}) {
      this.$refs.Threepartyfreight.init(row);
    },
    packagingmaterials(row = {}) {
      this.$refs.Plpackingmaterials.init(row);
    },
    selectrecipientList(){
      ajaxPost(Baseurl + "financeReportingController/getRecipientNameList").then(res => {
        if(res.data.code == 200){
          this.recipientList = res.data.data
        }
      });
    },
    getDialogListTabel() {
      var roleId = {
        page: this.currentPage2,
        size: this.pagesize2,
        roleId: this.UserInfo.rid,
        type: '2',
      };
      ajaxPost(Baseurl + "reserveFundController/selectReserveFundsByRoleId", roleId).then(res => {
        this.pettyCash = res.data.data.list;
        this.total2 = res.data.data.total;
        // console.log(res.data.data)
      });
    },
    Reservefund() {
      this.dialogTableVisible = true;
      this.getDialogListTabel()
    },
    handleSizeChange2(val) {
      this.pagesize2 = val;
      this.getDialogListTabel()
    },
    handleCurrentChange2(val) {
      this.currentPage2 = val;
      this.getDialogListTabel()
    },
    pettyCashSubmit() {
      var obj = {
        receiptMoney: this.receiptMoney,
        applyRoleId: this.UserInfo.rid,
        companyId: this.UserInfo.company_id,
        remark: this.remark,
      };
      ajaxPost(Baseurl + "reserveFundController/insertReserveFundApply", obj).then(res => {
        console.log(res.data);
        if (res.data.code == 200) {
          this.$message({
            message: "申请备用金成功",
            type: "success",
          });
          this.disabled = true;
        } else {
          this.$message.error("申请备用金失败");
          this.disabled = false;
        }
      });
      this.PettyCashApplication = false;
    },
    getTableList() {
      const API = Baseurl + "logisticsController/selectFinanceReportingList";
      const paramsData = {
        roleId: this.UserInfo.rid,
        page: this.page,
        size: this.size,
        hasBatchNo:this.formScreen.hasBatchNo,
        recipientName:this.formScreen.recipient,
        financeReportingType: this.formScreen.financeReportingType,
        startTimeString: this.formScreen.startTimeString,
        endTimeString: this.formScreen.endTimeString,
        searchString: this.formScreen.searchString,
        status: this.formScreen.status,
        batchNo:this.formScreen.batchNo,

        branchCompanyId: this.formScreen.BranchOffice,
        companyId: this.formScreen.Subsidiary,
      };
      this.loadingTable = true
      ajaxPost(API, paramsData).then(res => {
        this.loadingTable = false
        const { code, data } = res.data;
        if (code === 200) {
          this.balance = data.balance
          this.total = data.pageInfo.total;
          this.listTable = data.pageInfo.list;
        }
      });
    },
    freightcollectConfirm(data) {
      const API = Baseurl + "logisticsController/insertReceiptFreight";
      const paramsData = {
        companyId: this.UserInfo.company_id,
        financeReportingType: "1",
        roleId: this.UserInfo.rid,
        ...data,
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.$message.success("操作成功！");
          this.$refs.Freightcollect.close();
          this.getTableList();
        } else {
          this.$message.error(data)
        }
      });
    },
    plpackingmaterialsConfirm(data) {
      const API = Baseurl + "logisticsController/insertPackagingFreight";
      const paramsData = {
        roleId: this.UserInfo.rid,
        ...data,
      };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.$message.success("操作成功！");
          this.$refs.Plpackingmaterials.close();
          this.getTableList();
        } else {
          this.$message.error(data)
        }
      });
    },
    threepartyfreightConfirm(data) {
      const API = Baseurl + "logisticsController/updateFinanceReporting";
      const paramsData = {
        roleId: this.UserInfo.rid,
        // companyId: this.UserInfo.company_id,
        receiptNumber: "",
        status: "1",
        ...data,
      };
      ajaxPost(API, paramsData).then(res => {
        const { code } = res.data;
        if (code === 200) {
          this.$message.success("操作成功！");
          this.$refs.Threepartyfreight.close();
          this.$refs.Returnfreight.close();
          this.getTableList();
        } else {
          this.$message.error(data)
        }
      });
    },
    selectChange(id) {
      this.getSonCompanyList(id);
    },
    getBranchCompanyList() {
      const API = Baseurl + "logisticsController/getAllBranchCompany";
      ajaxPost(API).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listBranch = data;
        }
      });
    },
    getSonCompanyList(id) {
      const API = Baseurl + "logisticsController/getAllSubCompanyById";
      const paramsData = { id };
      ajaxPost(API, paramsData).then(res => {
        const { code, data } = res.data;
        if (code === 200) {
          this.listSon = data;
        }
      });
    },
    addThirdParty() {
      this.$refs.Threepartyfreight.init('', 'add');
    },
    downExcel: function () {
      const API = Baseurl + "logisticsController/exportFinanceReportingReturnList";
      const headers = { headers: 'application/x-download' };
      const blobs = { responseType: 'blob' }
      this.$http.post(API, headers, blobs).then(response => {
        const blob = new Blob([response.data], { type: "application/vnd.ms-excel" });
        //第一种
        const fileName = '退件地址.xls';
        const elink = document.createElement('a');
        elink.download = fileName;
        elink.style.display = 'none';
        elink.href = URL.createObjectURL(blob);
        document.body.appendChild(elink);
        elink.click();
        URL.revokeObjectURL(elink.href); // 释放URL 对象
        document.body.removeChild(elink);
        //        第二种
        //   const url = URL.createObjectURL(blob);
        //     window.location.href = url;
        //    window.location.href = response.data;
      })
    },
    handleThirdParty(data) {
      const API = Baseurl + 'logisticsController/insertSanChannelFreight'
      const paramsData = {
        roleId: this.UserInfo.rid,
        receiptNumber: "",
        status: "1",
        ...data,
      }
      ajaxPost(API, paramsData).then(res => {
        const { code } = res.data
        if (code === 200) {
          this.$message.success("操作成功！");
          this.$refs.Threepartyfreight.close();
          this.$refs.Returnfreight.close();
          this.getTableList();
        } else {
          this.$message.error(data)
        }
      })
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/{
  .forms .el-form-item{
      margin-bottom: 5px;
  }
}
</style>
<style lang="scss" scoped>
.information {
  width: 98%;
  overflow: hidden;
  padding-bottom: 72px;
}

.scope_img {
  width: 55px;
  height: 55px;

  img {
    width: 100%;
    height: 100%;
  }
}

.padding {
  padding: 10px 0;
}

.line-height {
  line-height: 45px;
}

.prduct_img {
  width: 500px;
  height: 500px;
}

.pagination-container {
  width: 1660px;
  padding: 20px;
  position: fixed;
  right: 0;
  bottom: 0;
  background: #fff;
  z-index: 999;

  .el-pagination {
    display: flex;
    justify-content: center;
  }
}
</style>
